<div fxLayout="column" class="page-container">
  <div class="top-image">
    <img ngSrc="assets/branding/top-traces2.png" alt="Top Traces" height="500" width="643" priority decoding="async">
  </div>
  <div fxLayout="column" class="sign-up-container" fxLayoutAlign="center center">
    <form [formGroup]="userData">
      <div class="input-container">
        <h1>Already played?<br> Enter your username!</h1>
        <eon-ui-input formControlName="userInput" placeholder="Enter username"></eon-ui-input>
        <eon-ui-form-message type="error" [message]="changeError()" [hidden]="!hasError()" scheme="white"></eon-ui-form-message>
      </div>
      <div fxLayout=column fxLayoutGap=15px class="button-container">
        <eon-ui-button  fullWidth=true text="Continue"  type=text (click)="confirm()" [disabled]="isEnabled()" scheme="white"></eon-ui-button>
        <eon-ui-button  fullWidth=true text="Go ahead without username"  type=text (click)="navigateToScore()" scheme="white"></eon-ui-button>
      </div>
      <div class="back-container">
        <eon-ui-button  rank=secondary fullWidth=true text="Back"  type=text (click)="navigateBack()" scheme="white"></eon-ui-button>
      </div>
    </form>
  </div>
  <div class="bottom-image">
    <img ngSrc="assets/branding/bottom-traces3.png" alt="Bottom Traces" height="500" width="1401"  loading="eager" decoding="async">
  </div>
</div>

